import PageRequest from '../../../../../pagination-helper/lib/PageRequest';

/**
 * * Модель запроса на получение списка очередей
 */
export default class ProjectQueueTaskListRequest  {
	/**
	 * * Поиск по названию очереди
	 */
	Search!: string;
	/**
	 * * Номер группы
	 */
	GroupId?: number;
	/**
	 * * Список номеров рабочих областей
	 */
	NamespacesId!: Array<string>;
	/**
	 * * Номер рабочей области
	 */
	QueueTaskId?: string;
	/**
	 * * Флаг только где исполнитель является текущим пользователем
	 */
	OnlyPerformerCurrentUser: boolean = false;
	/**
	 * * Пагинация
	 */
	Page!: PageRequest;
	constructor(obj?: Partial<ProjectQueueTaskListRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
